/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import intl from 'react-intl-universal';

import {formatSmartAbsoluteDate} from '../../helpers/DateHelper';
import {getCountryName} from "../place/GeoCountries";

import OutageCardTimeHeader from "./OutageCardTimeHeader";
import OutageSummary from "./OutageSummary";
import OutagePlaceList from "./OutagePlaceList";

export default class OutageMiniCard extends Component {

    renderHeader() {
        let outage = this.props.outage;

        let dimLength = outage.mainDimensionPath.length;
        let title = outage.mainDimensionPath[dimLength - 1];
        let subtitle = outage.mainDimensionPath.slice(0, dimLength - 1).reverse().join(', ');

        return (
            <div className="media-body">
                <h3 className="h6 mb-0">{title}</h3>
                <div className="small">
                    {subtitle}
                </div>
            </div>
        );
    }

    renderDate() {
        let outage = this.props.outage;

        return (
            <small className="d-block text-muted">{formatSmartAbsoluteDate(outage.startTime)}</small>
        );
    }

    renderState() {
        if (this.props.outage.active) {
            return (
                <span className="badge badge-danger ml-2">{intl.get('outage_ongoing')}</span>
            )
        } else if (this.props.outage.recent) {
            return (
                <span className="badge badge-warning ml-2">{intl.get('outage_today')}</span>
            )
        } else {
            return '';
        }
    }

    renderOutagePlace() {

        let region = this.props.outage.mainDimensionRegionValue;
        let country = this.props.outage.mainDimensionCountryValue;
        country = getCountryName(country);

        if (this.props.curCountry===country && this.props.curRegion===region) {
            return (<div/>);
        }


        return (
            <div className="d-flex">
                <div className="flex-column p-0 m-0">
                       {this.renderCountryFlag(this.props.outage.countryFlag)}
                </div>
                <div className="flex-column p-0 m-0">
                    <span className="align-middle small text-body">
                        {
                            region &&
                            <span>  {region}, </span>
                        }
                        {country}
                    </span>
                </div>
            </div>
            );
    }

    renderCountryFlag(flag) {
        if (flag) {
            return (
                <span className="align-middle small text-body">
                &nbsp;{flag}&nbsp;&nbsp;
                </span>
            );
        } else {
            return (
                <span>
                    <small className={"fas fa-fw fa-map-marker-alt text-secondary align-middle mr-2"}/>
                </span>
            );
        }

    }

    getBestTitle() {
        if (this.props.outage.mainDimensionIspBestName) return this.props.outage.mainDimensionIspBestName;
        if (this.props.outage.mainDimensionIspValue) return this.props.outage.mainDimensionIspValue;
        if (this.props.outage.mainDimensionRegionValue) return this.props.outage.mainDimensionRegionValue;
        return getCountryName(this.props.outage.mainDimensionCountryValue);
    }

    render() {
        return (
            <div className="container p-4">
                <div className="row">
                    {
                        this.props.showIsp &&
                        <div className="col-md-2 text-center">
                            <div className="avatar avatar-lg mb-2 ml-auto mr-auto">
                                <img className="avatar-img img-fluid" src={this.props.outage.imageUrl} alt="ISP Logo"/>
                            </div>
                            <h4 className="font-size-1 mb-0">
                                {this.getBestTitle()}
                            </h4>
                        </div>
                    }
                    <div className={this.props.showIsp ? "col-md-10" : "col-md-12"}>
                        <div className="d-flex justify-content-between mb-3">
                            <div className="flex-column">
                                <OutageSummary outage={this.props.outage}/>
                            </div>
                            <div className="flex-column">
                                <OutageCardTimeHeader outage={this.props.outage}/>
                            </div>
                        </div>

                        <div>
                            {this.renderOutagePlace()}

                            { this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='WideAreaImpact' compact='true' />
                            }
                            { !this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='City' compact='true' />
                            }

                            { !this.props.outage.wideAreaImpact &&
                                <OutagePlaceList outage={this.props.outage} dimension='Region' compact='true' />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}